import React, { useCallback, useMemo } from 'react';
import moment from 'moment';

import { css } from '@emotion/react';
import { headerLineHeight } from 'styles/global_defaults/fonts';
import { lightOrange } from 'athena/styles/colors';
import {
  gray6,
  gray2,
  black,
  warning,
} from 'styles/global_defaults/colors';

import ClickableContainer from 'components/clickable-container';

import { useAvailabilityCalendarContext } from './availability-calendar-context';
import { convertDateTime } from '../session-edit-mode';

import useTimeZone from 'athena/hooks/use-time-zone';

const styles = css`
  border-radius: 3px;
  border: 1px solid ${gray6};
  line-height: ${headerLineHeight}px !important;
  color: ${gray2};
  &.selected {
    border: 1px solid ${warning};
    background-color: ${lightOrange};
    color: ${black};
  }
  &:hover {
    color: ${black};
  }
`;

type TimeSlotProps = {
  startDate: string;
};

const TimeSlot = React.memo((props: TimeSlotProps) => {
  const { startDate } = props;
  const {
    selectedDate,
    setSelectedDate,
  } = useAvailabilityCalendarContext();

  const { ianaTimeZone } = useTimeZone();

  const isSelected = useMemo(() => (
    moment(selectedDate).isSame(moment(startDate))
  ), [selectedDate, startDate]);

  const handleClick = useCallback(() => {
    const convertedDate = convertDateTime({
      date: startDate,
      timeZone: ianaTimeZone,
      convert: false,
    });
    setSelectedDate(convertedDate);
  }, [setSelectedDate, startDate]);

  return (
    <ClickableContainer
      className={`slot mb-1 px-2 py-1 text-regular semi-bold ${isSelected ? 'selected' : ''}`}
      css={styles}
      onClick={handleClick}
    >
      {moment(startDate).format('hh:mm a')}
    </ClickableContainer>
  );
});

export default TimeSlot;
